// Single axios instance for the whole frontend. All thunks/components should
// import from here instead of constructing their own clients or hardcoding the
// base URL.
import axios from "axios";

// Both prefixes accepted — vite.config.js bridges REACT_APP_* through
// `process.env` for legacy code while new code can read VITE_* directly.
const baseURL =
  import.meta.env?.VITE_API ||
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_API) ||
  "/api";

const apiClient = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// 401 hook — wired by main.jsx so we don't create a circular dep between
// the client and the userActions module.
let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      typeof onUnauthorized === "function"
    ) {
      onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default apiClient;
